
"use client";
import React from 'react'
import Reveal from "./Reveal";

const Eligibility = () => {
  return (
    <section id="eligibility" className="py-14 md:py-20 bg-white">
      <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto ">
        <div className="grid lg:grid-cols-2 gap-0 md:gap-14 items-center">
          <Reveal>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-0.5 bg-[#FFA201]" />
              <span className="text-[#0475B3] text-xs font-black uppercase tracking-widest">Eligibility</span>
            </div>
            <h2 className="text-4xl font-black text-[#081E2D] mb-8 leading-tight">Who Can Apply?</h2>

            <div className="space-y-5">
              {[
                {
                  color: "#0475B3", label: "Full-Time", bg: "#EBF5FB",
                  items: ["Master's degree in relevant or allied discipline", "Minimum 55% marks or equivalent CGPA", "Relaxation applicable as per UGC norms"],
                },
                {
                  color: "#F47721", label: "Part-Time", bg: "#FFF4EC",
                  items: ["Must be employed in a recognised organisation", "No Objection Certificate (NOC) required", "Workplace research facility availability required"],
                },
              ].map((type) => (
                <div key={type.label} className="rounded-2xl border overflow-hidden"
                  style={{ borderColor: `${type.color}30` }}>
                  <div className="px-5 py-3 flex items-center gap-2" style={{ backgroundColor: type.bg }}>
                    <div className="w-7 h-7 rounded-lg flex items-center justify-center text-white font-black text-sm" style={{ backgroundColor: type.color }}>
                      {type.label[0]}
                    </div>
                    <span className="font-black text-[#081E2D] text-lg">{type.label} Research Scholars</span>
                  </div>
                  <div className="p-5">
                    <ul className="space-y-2.5">
                      {type.items.map((item) => (
                        <li key={item} className="flex items-start gap-3 text-md text-gray-600">
                          <svg className="w-4 h-4 mt-0.5 shrink-0" style={{ color: type.color }} fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414L8.414 15l-4.121-4.121a1 1 0 011.414-1.414L8.414 12.172l7.879-7.879a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}

              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-5 flex items-start gap-3">
                <span className="text-2xl shrink-0">🎯</span>
                <div>
                  <p className="font-bold text-[#081E2D] text-lg">Aptitude Test Exemption</p>
                  <p className="text-gray-600 text-md mt-0.5">Exemption available for UGC-NET / JRF / CSIR-NET qualified candidates.</p>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={150}>
            <div className='flex justify-center items-center'>
              <img
                src="https://cdn.msu.edu.in/msu-reavamp/phd/Who-Can-Apply.webp"
                alt="Students researching"
                className="rounded-sm w-full h-125 object-cover shadow-xl hidden md:block"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default Eligibility